import { render } from "./indexData.vue?vue&type=template&id=5e90c252&scoped=true"
import script from "./indexData.vue?vue&type=script&lang=js"
export * from "./indexData.vue?vue&type=script&lang=js"

import "./indexData.vue?vue&type=style&index=0&id=5e90c252&scoped=true&lang=css"

import exportComponent from "G:\\phpstudy_pro\\WWW\\xsr SYETEM\\vue-webagent\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e90c252"]])

export default __exports__